import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchDistricts, fetchDistrict } from "@/lib/api";

const DistrictContext = createContext(null);

export const DistrictProvider = ({ children }) => {
    const [districts, setDistricts] = useState([]);
    const [slug, setSlug] = useState(() => localStorage.getItem("mjh.district") || "varanasi");
    const [district, setDistrict] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await fetchDistricts();
                if (!cancelled) setDistricts(data);
            } catch {
                if (!cancelled) setDistricts([]);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!cancelled) setLoading(true);
            try {
                const d = await fetchDistrict(slug);
                if (!cancelled) setDistrict(d);
            } catch {
                if (!cancelled) setDistrict(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        localStorage.setItem("mjh.district", slug);
        return () => { cancelled = true; };
    }, [slug]);

    return (
        <DistrictContext.Provider value={{ districts, slug, setSlug, district, loading }}>
            {children}
        </DistrictContext.Provider>
    );
};

export const useDistrict = () => useContext(DistrictContext);
